import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unitConvert',
})
export class UnitConvertPipe implements PipeTransform {
  transform(value: number, prefix: string = ' ', suffix: string = '', scale: 'm2' | 'ft2' | 'miles' | 'both' = 'm2'): string {
    const sqftTransform = `${prefix}${Math.round(value * 10.7639)}${suffix} ft² `;
    const sqmTransform = `${prefix}${Math.round(value)}${suffix} m²`;
    const milesTransform = `${prefix}${Math.round(value * 0.000621371192 * 100) / 100}${suffix}`;

    switch (scale) {
      case 'both':
        return `${sqmTransform} | ${sqftTransform}`;
      case 'ft2':
        return sqftTransform;
      case 'miles':
        return milesTransform;
      case 'm2':
      default:
        return sqmTransform;
    }
  }
}
